import { Component, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ContactsPageService } from 'src/api/services';
import { ContactsPageListResponseDataItem } from 'src/api/models';
import { DomSanitizer, Meta, SafeResourceUrl, Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
import { error } from 'console';


@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1000ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('1000ms', style({ opacity: 0 }))
      ])
    ]
    )
  ]
})

export class ContactsComponent implements OnInit {

  constructor(
    public meta: Meta,
    public title: Title,
    public contactsPageService: ContactsPageService,
    public appService: AppService,
    public sanitizer: DomSanitizer,
    private http: HttpClient) { }
  authorName: string;
  dataMail: MailMessage = new MailMessage();
  messageSended: boolean;
  isError: boolean;
  loading: boolean;
  isFrameLoading: boolean = true;
  captha: boolean;
  pageData: ContactsPageListResponseDataItem;
  urlSafeMapUrl: SafeResourceUrl;
  ngOnInit(): void {
    this.setSEO();
    this.contactsPageService.getContactsPage().subscribe(result => {
      this.pageData = (result.data as ContactsPageListResponseDataItem);
      this.urlSafeMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pageData.attributes.URLforMap);
    });
  }
  resolved(res: string) {
    this.captha = true;
  }
  sendMessage() {
    var param = {
      email: this.dataMail.from,
      subject: this.dataMail.subject,
      text: this.dataMail.text
    }
    this.http.post<any>(this.appService.baseUrl + '/api/emails', param)
      .subscribe(data => {
        this.messageSended = true;
      }, error => { console.log(error) });
  }

  setSEO() {

    if (this.pageData && this.pageData.attributes.Seo) {
      this.meta.updateTag({ name: 'keywords', content: this.pageData.attributes.Seo.keywords });
      this.meta.updateTag({ name: 'description', content: this.pageData.attributes.Seo.metaDescription });
      this.title.setTitle(this.pageData.attributes.Seo.metaTitle);
    } else {
      this.meta.removeTag('name= "keywords"');
      this.meta.removeTag('name= "description"');
      this.title.setTitle('');
    }
    this.meta.removeTag('name= "robots"');
  }

}
export class MailMessage {
  from: string;
  subject: string;
  text: string;
}
